__turbopack_context__.v({
  "border--none": "V3UjHW_border--none",
  "borderColor--warning": "V3UjHW_borderColor--warning",
  "colorScheme--muted": "V3UjHW_colorScheme--muted",
  "colorScheme--none": "V3UjHW_colorScheme--none",
  "container": "V3UjHW_container",
  "field": "V3UjHW_field",
  "icon": "V3UjHW_icon",
  "input": "V3UjHW_input",
  "isEmpty": "V3UjHW_isEmpty",
  "size--lg": "V3UjHW_size--lg",
  "size--sm": "V3UjHW_size--sm",
  "width--maxcontent": "V3UjHW_width--maxcontent",
  "wiggle--a": "V3UjHW_wiggle--a",
  "wiggle--b": "V3UjHW_wiggle--b",
});
